import { useBackend } from "../../services";
import { useGetPaginatedAttributes } from "../attributes/useGetPaginatedAttributes";
import { IOriginCountry } from "./interfaces";
import {
  IGetPaginatedAttributeProps,
  IPublicGetPaginatedAttributeProps
} from "../attributes/interfaces";
import { useCollectionManager } from "../collections/useCollectionManager";
import { PageSizeHelper } from "../../models/PageSizeHelper";
import { useUser } from "../session";
import { UserRole } from "../users";
import { DataStorage } from "../../models/DataStorage";

export const useGetOriginCountries = (
  isPublic: boolean,
  setLoading: (loading: boolean) => void
) => {
  const { get } = useBackend();
  const { getCurrentCollection } = useCollectionManager();
  const [currentUser] = useUser.useState();
  const getOriginCountries = (parameters: IGetPaginatedAttributeProps) =>
    get("originCountries", parameters);
  const getPublicOriginCountries = (parameters: IPublicGetPaginatedAttributeProps) =>
    get("originCountries/shared/public", parameters);
  return useGetPaginatedAttributes<IOriginCountry>(
    PageSizeHelper.tags(currentUser?.role ?? UserRole.common),
    isPublic ? getPublicOriginCountries : getOriginCountries,
    setLoading,
    DataStorage.originCountryStorage,
    isPublic,
    true,
    getCurrentCollection(isPublic)?.uuid
  );
};
